// ค้นหาสินค้า — overlay ค้นสดจาก catalog (client-side: name/kw/sku/หมวด)
import { useEffect, useMemo, useState } from 'react';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import { fmt } from '../lib/money.js';
import { stripInvisible } from '../lib/text.js';
import { CATS } from '../data/catalog.js';

export default function SearchOverlay({ nav }) {
  const { searchOpen, setSearchOpen, products } = useStore();
  const { t } = useI18n();
  const [q, setQ] = useState('');

  useEffect(() => {
    if (!searchOpen) { setQ(''); return; }
    const onKey = (e) => { if (e.key === 'Escape') setSearchOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [searchOpen]);

  const s = stripInvisible(q).trim().toLowerCase();
  const results = useMemo(() => {
    if (s.length < 2) return [];
    return products
      .filter((p) => `${p.name} ${p.kw || ''} ${p.sku} ${p.cat || ''}`.toLowerCase().includes(s))
      .sort((a, b) => (a.tag === 'sold' ? 1 : 0) - (b.tag === 'sold' ? 1 : 0))
      .slice(0, 12);
  }, [s, products]);

  if (!searchOpen) return null;

  const open = (p) => { setSearchOpen(false); nav(`/p/${p.id || p.sku}`); };

  return (
    <div className="search-scrim" onClick={() => setSearchOpen(false)}>
      <div className="search-panel" onClick={(e) => e.stopPropagation()}>
        <div className="search-bar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)}
            placeholder={t('search.ph')} />
          <button className="search-x" onClick={() => setSearchOpen(false)} aria-label="ปิด">✕</button>
        </div>
        <div className="search-results">
          {s.length < 2 && <div className="search-hint">{t('search.min')}</div>}
          {s.length >= 2 && !results.length && <div className="search-hint">{t('search.none', q)}</div>}
          {results.map((p) => (
            <button key={p.id || p.sku} className="search-row" onClick={() => open(p)}>
              <span className="search-thumb">{p.imgs && p.imgs[0] ? <img src={p.imgs[0]} alt="" loading="lazy" /> : null}</span>
              <span className="search-info">
                <span className="search-name">{p.name}</span>
                <span className="search-meta">{(CATS[p.cat] || {}).t || p.cat}{p.tag === 'sold' ? t('search.sold') : ''}</span>
              </span>
              <span className="search-price">{p.price != null ? fmt(p.price) : t('pdp.ask')}</span>
            </button>
          ))}
          {results.length >= 12 && <div className="search-hint">{t('search.top12')}</div>}
        </div>
      </div>
    </div>
  );
}
